import React, { useCallback, useEffect, useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { chevronLeft } from 'react-icons-kit/feather'
import SingleSelect from '../../../../components/select/Single'
import { toast } from 'react-toastify'
import { api } from "../../../../utils/api";
import axios from 'axios'

const Create = () => {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    const [admin, setAdmin] = useState({ value: null, options: [], error: null })
    const [type, setType] = useState({ value: null, error: null })
    const [method, setMethod] = useState({ value: null, error: null })
    const [isLoading, setLoading] = useState(false)

    const handleAdmin = event => setAdmin({ ...admin, value: event.value, error: null })
    const handleMethod = event => setMethod({ ...method, value: event.value, error: null })
    const handleType = event => setType({ ...type, value: event.value, error: null })

    const typeOptions = [
        { label: 'Office Rent', value: 'Office Rent' },
        { label: 'Salary', value: 'Salary' },
        { label: 'Utility', value: 'Utility' },
        { label: 'Mobile Recharge', value: 'Mobile Recharge' },
        { label: 'Others', value: 'Others' }
    ]
    
    const paymentOptions = [
        { label: 'Cash', value: 'Cash' },
        { label: 'Check', value: 'Check' }
    ]

    // Fetch data
    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${api}auth/index`, header)
            if (response.status === 200) {
                setAdmin({
                    ...admin,
                    options: response.data && response.data.adminList.map(item => ({
                        label: item.name + ' - ' + item.email,
                        value: item._id
                    }))
                })
            }

        } catch (error) {
            if (error) console.log(error)
        }
    }, [header])

    useEffect(() => {
        fetchData()
    }, [header, fetchData])

    // Submit Form
    const onSubmit = async (data) => {
        try {
            if (!type.value) return setType({ ...type, error: 'Payment type is required' })
            if (!method.value) return setMethod({ ...method, error: 'payment method is required' })
            setLoading(true)
            const formData = {
                ...data,
                type: type.value,
                method: method.value,
                careOf: admin.value
            }
            const res = await axios.post(`${api}account/expense/create`, formData, header)
            if(res.data.status){
                setLoading(false)
                toast.success(res.data.message)
                navigate('/dashboard/accounts/expense')
            }
        } catch (error) {
            if (error) console.log(error)
        }
    }

    return (
        <div className="expence-create pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Create Expense</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/accounts/expense"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">

                                        {/* Admin */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {admin.error ? <p className="text-danger">{admin.error}</p> : <p>C/O</p>}
                                                <SingleSelect
                                                    placeholder="Admin"
                                                    options={admin.options}
                                                    error={admin.error}
                                                    value={handleAdmin}
                                                />
                                            </div>
                                        </div>
                                        {/* Amount */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.amount && errors.amount.message ? (
                                                    <p className="text-danger">{errors.amount && errors.amount.message}</p>
                                                ) : <p>Amount (TK)</p>}
                                                <input
                                                    type="number"
                                                    name="amount"
                                                    placeholder="Enter amount"
                                                    className="form-control shadow-none"
                                                    {...register("amount", { required: "Amount is required." })}
                                                />
                                            </div>
                                        </div>

                                        {/* Date */}
                                        <div className="col-12 col-lg-4">
                                            <div className="form-group mb-4">
                                                {errors.date && errors.date.message ? (
                                                    <p className="text-danger">{errors.date && errors.date.message}</p>
                                                ) : <p>Date</p>}
                                                <input
                                                    type="date"
                                                    name="date"
                                                    placeholder="Select Date"
                                                    className="form-control shadow-none"
                                                    {...register("date", { required: "Date is required." })}
                                                />
                                            </div>
                                        </div>

                                        {/* Expense Type */}
                                        <div className="col-12 col-lg-4">
                                            <div className="form-group mb-4">
                                                { type.error ? ( <p className="text-danger">{type.error}</p> ) : <p>Expense Type</p>}
                                                <SingleSelect
                                                    placeholder="Type"
                                                    options={typeOptions}
                                                    error={type.error}
                                                    value={handleType}
                                                />
                                            </div>
                                        </div>

                                        {/* Payment method */}
                                        <div className="col-12 col-lg-4">
                                            <div className="form-group mb-4">
                                            { method.error ? ( <p className="text-danger">{method.error}</p> ) : <p>Payment method</p> }
                                                <SingleSelect
                                                    placeholder="Method"
                                                    options={paymentOptions}
                                                    error={method.error}
                                                    value={handleMethod}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Comment */}
                                    <div className="form-group mb-4">
                                        {errors.comment && errors.comment.message ? (
                                            <p className="text-danger">{errors.comment && errors.comment.message}</p>
                                        ) : <p>Comment</p>}

                                        <textarea
                                            name="comment"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Write comment"
                                            maxLength={50}
                                            {...register("comment", { required: "Comment is required." })}
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Creating...' : 'Create'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Create;